import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { LoaderService } from "../../services/loader.service";

@Component({
  selector: "app-loader",
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  template: `
    <div class="loader-overlay" *ngIf="loaderService.loading$ | async">
      <mat-progress-spinner
        mode="indeterminate"
        color="primary"
      ></mat-progress-spinner>
    </div>
  `,
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent {
  constructor(public loaderService: LoaderService) {}
}
